import 'select2'
import 'dm-file-uploader'
import datepicker from 'js-datepicker'

/* global ajaxObj */

export default {
  init() {
    if ($('body.logged-in').length) {
      $('.js-login-btn a').text('My Account')
    }

    this.userLogInHandler()
    this.forgotPassword()
    this.resetPassword()
    this.getTransactionInfo()
    this.dropArea()

    $('input[type="date"].js-transaction-date').each(function () {
      const el = this
      $(el).attr('type', 'text').attr('autocomplete', 'off')

      var dateNow = new Date()
      datepicker(el, {
        minDate: new Date(),
        maxDate: new Date(dateNow.setDate(dateNow.getDate() + 240)),
        formatter: (input, date) => {
          input.value = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split('T')[0]
        },
      })
    })
  },
  dropArea() {
    const $dropArea = $('#drop-area')
    const $files = $('#files')
    function ui_multi_add_file(id, file) {
      var template = $('#files-template').text()
      template = template.replace('%%filename%%', file.name)

      template = $(template)
      template.prop('id', 'uploaderFile' + id)
      template.data('file-id', id)

      //$files.find('li.empty').fadeOut() // remove the 'no files yet'
      $files.prepend(template)
    }

    // Changes the status messages on our list
    function ui_multi_update_file_status(id, status, message) {
      $('#uploaderFile' + id)
        .find('span')
        .html(message)
        .prop('class', 'status text-' + status)
    }

    // Updates a file progress, depending on the parameters it may animate it or change the color.
    function ui_multi_update_file_progress(id, percent, color, active) {
      color = typeof color === 'undefined' ? false : color
      active = typeof active === 'undefined' ? true : active

      var bar = $('#uploaderFile' + id).find('div.progress-bar')

      bar.width(percent + '%').attr('aria-valuenow', percent)
      bar.toggleClass('progress-bar-striped progress-bar-animated', active)

      if (percent === 0) {
        bar.html('')
      } else {
        bar.html(percent + '%')
      }

      if (color !== false) {
        bar.removeClass('bg-success bg-info bg-warning bg-danger')
        bar.addClass('bg-' + color)
      }
    }

    if ($dropArea.length) {
      $dropArea.dmUploader({
        url: ajaxObj.ajax_url,
        extraData: function () {
          return {
            action: 'pch_upload_file',
            transactionId: $('[name="transactions-select"]').val(),
          }
        },
        maxFileSize: 10000000,
        onDragEnter: function () {
          // Happens when dragging something over the DnD area
          this.addClass('active')
        },
        onDragLeave: function () {
          // Happens when dragging something OUT of the DnD area
          this.removeClass('active')
        },
        onNewFile: function (id, file) {
          // When a new file is added using the file selector or the DnD area
          ui_multi_add_file(id, file)
        },
        onBeforeUpload: function (id) {
          // about tho start uploading a file
          ui_multi_update_file_status(id, 'uploading', 'Uploading...')
          ui_multi_update_file_progress(id, 0, '', true)
        },
        onUploadCanceled: function (id) {
          // Happens when a file is directly canceled by the user.
          ui_multi_update_file_status(id, 'warning', 'Canceled by User')
          ui_multi_update_file_progress(id, 0, 'warning', false)
        },
        onUploadProgress: function (id, percent) {
          // Updating file progress
          ui_multi_update_file_progress(id, percent)
        },
        onUploadSuccess: function (id) {
          // A file was successfully uploaded
          ui_multi_update_file_status(id, 'success', 'Upload Complete')
          ui_multi_update_file_progress(id, 100, 'success', false)
          var $transactionsSelect = $('.js-transactions-select')
          console.log('$transactionsSelect', $transactionsSelect) //eslint-disable-line
          if ($transactionsSelect.length) {
            $transactionsSelect.change()
          }
        },
        onUploadError: function (id, xhr, status, message) {
          ui_multi_update_file_status(id, 'danger', message)
          ui_multi_update_file_progress(id, 0, 'danger', false)
        },
      })
    }
  },
  userLogInHandler() {
    const $loginForm = $('.login-page #loginform')
    $loginForm.on('submit', function (event) {
      event.preventDefault()

      $loginForm.addClass('submitting')
      // eslint-disable-next-line
      $.post(ajaxObj.ajax_url, {
        action: 'login_form',
        data: $loginForm.serialize(),
      }).success(response => {
        if (Object.keys(response).length) {
          $loginForm.removeClass('submitting')
          $loginForm.find('.common-login-error').remove()
          $loginForm.append(
            `<p class="text-center common-login-error">Your credentials are incorrect.</p>`
          )
        } else {
          setTimeout(() => window.location.reload(), 100)
        }
      })
    })
  },
  getTransactionInfo() {
    var $transactionsSelect = $('.js-transactions-select')
    if ($transactionsSelect.length) {
      var $transationCalc = $('.js-transation-calc')
      var $transationFiles = $('.js-transation-files')
      var $transationQuote = $('.js-transation-quote')

      $transactionsSelect.on('change', function () {
        const val = $(this).val()
        $.ajax({
          method: 'POST',
          url: ajaxObj.ajax_url,
          dataType: 'json',
          data: {
            action: 'pch_get_transaction_info',
            transactionId: val,
          },
          beforeSend: function () {
            $transactionsSelect.addClass('processing')
            $transationCalc.addClass('processing')
            $transationQuote.addClass('processing')
            $transationFiles.addClass('processing')
          },
          success: function (response) {
            $transactionsSelect.removeClass('processing')
            $transationCalc.removeClass('processing')
            $transationQuote.removeClass('processing')
            $transationFiles.removeClass('processing')
            if (response) {
              $transationCalc.html(response.transationCalcHtml)
              $transationQuote.html(response.transationQuoteHtml)
              $transationFiles
                .find('.js-transation-files-select')
                .html(response.transationDocsHtml)
              $transationFiles.find('select').select2({
                minimumResultsForSearch: -1,
              })
              //$('#files li').remove()
            }
          },
          error: function (error) {
            $transactionsSelect.removeClass('processing')
            $transationCalc.removeClass('processing')
            $transationQuote.removeClass('processing')
            $transationFiles.removeClass('processing')
            console.log('error', error) //eslint-disable-line
          },
        })
      })

      $('.js-transation-files')
        .on('change', '.js-transaction-files-select', function () {
          const $this = $(this)
          const val = $this.val()
          $.ajax({
            method: 'POST',
            url: ajaxObj.ajax_url,
            dataType: 'json',
            data: {
              action: 'pch_set_active_transaction_file',
              rowId: val,
              transactionId: function () {
                return $transactionsSelect.val()
              },
            },
            beforeSend: function () {
              $transactionsSelect.addClass('processing')
              $transationCalc.addClass('processing')
              $transationFiles.addClass('processing')
            },
            success: function (response) {
              $transactionsSelect.removeClass('processing')
              $transationCalc.removeClass('processing')
              $transationFiles.removeClass('processing')
              console.log('response', response) //eslint-disable-line
              if (response && response.status === 'ok') {
                $transactionsSelect.change()
              }
            },
            error: function (error) {
              $transactionsSelect.removeClass('processing')
              $transationCalc.removeClass('processing')
              $transationFiles.removeClass('processing')
              console.log('error', error) //eslint-disable-line
            },
          })
        })
        .on('change', '.js-transaction-file-types-select', function () {
          const $this = $(this)
          const val = $this.val()
          const rowId = $this
            .closest('.js-transation-files-select')
            .find('.js-transaction-files-select')
            .val()
          $.ajax({
            method: 'POST',
            url: ajaxObj.ajax_url,
            dataType: 'json',
            data: {
              action: 'pch_set_transaction_file_type',
              rowId: rowId,
              type: val,
              transactionId: function () {
                return $transactionsSelect.val()
              },
            },
            beforeSend: function () {
              $transactionsSelect.addClass('processing')
              $transationCalc.addClass('processing')
              $transationFiles.addClass('processing')
            },
            success: function (response) {
              $transactionsSelect.removeClass('processing')
              $transationCalc.removeClass('processing')
              $transationFiles.removeClass('processing')
              console.log('response', response) //eslint-disable-line
              if (response && response.status === 'ok') {
                $transactionsSelect.change()
              }
            },
            error: function (error) {
              $transactionsSelect.removeClass('processing')
              $transationCalc.removeClass('processing')
              $transationFiles.removeClass('processing')
              console.log('error', error) //eslint-disable-line
            },
          })
        })
    }
  },
  forgotPassword() {
    const $lostPassForm = $('#lostpasswordform')
    if ($lostPassForm.length) {
      $lostPassForm.on('submit', function (event) {
        event.preventDefault()

        $lostPassForm.addClass('submitting')
        // eslint-disable-next-line
        $.post(ajaxObj.ajax_url, {
          action: 'pch_forgot_pass',
          data: $lostPassForm.serialize(),
        }).success(response => {
          if (response === true) {
            setTimeout(() => {
              window.location.href = $lostPassForm.attr('action')
            }, 100)
          } else if (
            Object.keys(response).length &&
            Object.keys(response.errors).length
          ) {
            const errorKey = Object.keys(response.errors)[0]
            $lostPassForm.removeClass('submitting')
            $lostPassForm.find('.common-login-error').remove()
            $lostPassForm.append(
              `<p class="text-center common-login-error">${response.errors[errorKey][0]}</p>`
            )
          }
        })
      })
    }
  },
  resetPassword() {
    const $resPassForm = $('#resetpassform')
    if ($resPassForm.length) {
      $resPassForm.on('submit', function (event) {
        event.preventDefault()

        let data = {}
        $.each($resPassForm.serializeArray(), function () {
          data[this.name] = this.value
        })

        if (!data.pass1.length || !data.pass2.length) {
          $resPassForm.find('.common-login-error').remove()
          $resPassForm.append(
            `<p class="text-center common-login-error">Fields are requiered.</p>`
          )
        } else if (
          data.pass1.length &&
          data.pass2.length &&
          data.pass1 !== data.pass2
        ) {
          $resPassForm.find('.common-login-error').remove()
          $resPassForm.append(
            `<p class="text-center common-login-error">Passwords do not match.</p>`
          )
        } else {
          $resPassForm.addClass('submitting')
          // eslint-disable-next-line
          $.post(ajaxObj.ajax_url, {
            action: 'pch_reset_pass',
            data: $resPassForm.serialize(),
          }).success(response => {
            if (response && response.status) {
              setTimeout(() => {
                window.location.href =
                  $resPassForm.attr('action') + '?rp=' + response.status
              }, 100)
            }
          })
        }
      })
    }
  },
  onResize() {
    $(window).resize(() => {})
  },
}
